var e=Object.freeze({upload:"Upload profile image",edit:"Change position",delete:"Remove avatar"});export{e as ProfileImageEditorViewTitle};
//# sourceMappingURL=ProfileImageEditor.constants.js.map
